<script setup>

import {onBeforeMount, onMounted, onUpdated, ref} from "vue";
import axios from "@/axios";
import {useComStore, useLanguageStore} from "@/pinia";

const props = defineProps(['readonly', 'committee', 'label']);
const emits = defineEmits(['set_committee']);
const selectedCommittee = ref("");
const isReadonly = ref();
const items =  ref();
const useComCode = useComStore();
const languageStore = useLanguageStore();

const changeCommittee = (c)=>{
  selectedCommittee.value = c;
  emits("set_committee", c);
}

onUpdated(()=>{
  isReadonly.value = props.readonly ?? false;
})
onBeforeMount(()=>{
  selectedCommittee.value = props.committee ?? null;
})
onMounted(()=>{
  items.value = useComCode.getCodeType("committee");
})
</script>

<template>
  <v-select
      v-model="selectedCommittee"
      @update:modelValue="changeCommittee"
      :items="items"
      item-value="codeId"
      item-title="codeNm"
      :readonly="isReadonly"
      :label="label"
      :placeholder="!label ? languageStore.get('select') : undefined"
      variant="outlined"
      density="compact"
      hide-details="auto"
  />
</template>

<style scoped>

</style>